

import React, { PureComponent } from 'react';
import { createContainer } from '@dbk-legacy/muster/react';
import { FormattedMessage } from '@dbk-legacy/format';
import { LoadingCircle } from '../../../components/common/loading';
import { SuccessIcon } from '../../../components/common/icons';
import Button from '@dbk/ui-buttons';
import { PALETTE } from '../../../constants';

class SepaTransactionLimitSuccess extends PureComponent {
  constructor(props) {
    super(props);
  }

  render() {
    const { i18n: { messages }} = this.props;

    return(
      <div className='reportAdhocSuccess'>
        <SuccessIcon color={PALETTE.successIcon} width={48} height={48} />

        <div className='reportAdhocSuccess__message'>
          <h2 tabIndex={0}>
            {messages['app.payments.confirmation.success']}
          </h2>
          <p tabIndex={0}>
            <FormattedMessage
              id='app.sepaip.limit.success.message'
              values={{
                limit: this.props.sepaLimit.sepaTransactionLimit,
              }}
            />
          </p>
        </div>

        <div className='reportAdhocSuccess__actionBtn'>
          <Button
                size='large'
                tertiary
                fullWidth={false}
                onClick={() => this.props.changePage('/profile/manage-sepa-transaction-limit')}>
                  {messages['app.sepaip.limit.set.new.button']}
          </Button>

            <Button
              size='large'
              onClick={() => this.props.changePage('/profile/portfolio')}
              fullWidth={false}>
                {messages['app.sepaip.go.to.preferences.button']}
            </Button>
        </div>
      </div>
    )
  }
 
 
  }

export default createContainer({
  $renderLoading: () => <LoadingCircle />,
  $queries: {
   
    changePage: { $call: 'ui.history.push' },
    i18n: {
      messages: true,
    },
    rsa: {
      onChangePage: { $call: 'changePage' },
    },
    sepaLimit: {
      sepaTransactionLimit: true,
    },
    goBack: { $call: 'ui.history.goBack' },


  },
})(SepaTransactionLimitSuccess);
